import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "../data/content";

const cols = [
  {
    title: "Experiences",
    links: [
      ["Celebrity Appearances", "/experiences/celebrity-appearances"],
      ["Concerts & Live Shows", "/experiences/concerts-live-shows"],
      ["Luxury Weddings", "/experiences/luxury-weddings"],
      ["Corporate Events", "/experiences/corporate-events"],
      ["Brand Launches", "/experiences/brand-showroom-launches"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About", "/about"],
      ["Portfolio", "/portfolio"],
      ["Production", "/production"],
      ["Celebrity & Talent", "/celebrity-talent"],
      ["Locations", "/locations"],
      ["Contact", "/contact"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Policy", "/privacy-policy"],
      ["Terms", "/terms"],
      ["Disclaimer", "/disclaimer"],
    ],
  },
];

export const Footer = () => (
  <footer className="bg-[#0D1018] border-t border-[#C9A55C]/15 pb-24 md:pb-0" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
      <div className="flex flex-col lg:flex-row justify-between gap-12">
        <div className="max-w-sm">
          <p className="font-display text-2xl tracking-[0.15em] text-[#F3EEE5]">MEGA</p>
          <p className="text-[0.6rem] tracking-[0.4em] text-[#C9A55C] uppercase mt-1">Celebrity Events</p>
          <p className="mt-6 text-sm text-[#A9ABB2] leading-relaxed">
            Celebrity experiences, luxury celebrations and powerful event production across Andhra Pradesh and Telangana.
          </p>
          <p className="mt-6 font-accent italic text-lg text-[#F3EEE5]/80">
            “Where Every Entrance Becomes a Moment.”
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-10">
          {cols.map((col) => (
            <div key={col.title}>
              <p className="text-[0.65rem] uppercase tracking-[0.3em] text-[#C9A55C] mb-4">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-sm text-[#A9ABB2] hover:text-[#F3EEE5] transition-colors duration-300">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-[#F3EEE5]/8 flex flex-col md:flex-row justify-between gap-6">
        <div className="space-y-2 text-sm text-[#A9ABB2]">
          <a href={`tel:${CONTACT.phonePrimaryRaw}`} className="flex items-center gap-2 hover:text-[#C9A55C] transition-colors" data-testid="footer-phone">
            <Phone size={14} className="text-[#C9A55C]" /> {CONTACT.phonePrimary} &nbsp;·&nbsp; {CONTACT.phoneSecondary}
          </a>
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-[#C9A55C] transition-colors" data-testid="footer-email">
            <Mail size={14} className="text-[#C9A55C]" /> {CONTACT.email}
          </a>
          <p className="flex items-start gap-2 max-w-md">
            <MapPin size={14} className="text-[#C9A55C] mt-1 shrink-0" /> {CONTACT.address}
          </p>
        </div>
        <div className="flex flex-col items-start md:items-end gap-4">
          <p className="font-accent italic text-lg text-[#F3EEE5]/80">Have an occasion in mind?</p>
          <Link to="/plan-your-event" className="btn-gold" data-testid="footer-create-event-btn">
            Create Your Event
          </Link>
        </div>
      </div>

      <p className="mt-10 text-xs text-[#A9ABB2]/50">
        © {new Date().getFullYear()} Mega Celebrity Events. All rights reserved.
      </p>
    </div>
  </footer>
);
